module.exports = {
    handle: (e, data) => {           
        console.log('eec:internalPromotionClicks:handler');
    }
}